// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"9f2ddfbe","146":"fa269a4b","154":"e8f8afc2","188":"8d59b7a0","192":"2289e66c","445":"beeb573a","446":"70cc3600","452":"51407c60","562":"6600844e","567":"024c1572","607":"04adb6c3","647":"2638e760","659":"51d00daf","681":"7291ed5a","684":"e4e063f4","954":"62180c03"}[chunkId] + ".chunk.js";
};